import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LinkInBio from './components/LinkInBio';
import Analytics from './components/Analytics';
import RunIt from './components/RunIt';
import AdminLogin from './components/AdminLogin';
import AdminLeads from './components/AdminLeads';
import Built from './components/Built';
import Opportunity from './components/Opportunity';
import AdminBuilt from './components/AdminBuilt';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LinkInBio />} />
          <Route path="/run-it" element={<RunIt />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/built" element={<Built />} />
          <Route path="/opportunity" element={<Opportunity />} />
          <Route path="/admin/built" element={<AdminBuilt />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
